import { Pipe, PipeTransform } from '@angular/core';
const ticksToDate = require('ticks-to-date');
const moment = require('jalali-moment');

@Pipe({
  name: 'ticksToDate',
})
export class TicksToDatePipe implements PipeTransform {

  transform(tickDate: number): string {
    const date = ticksToDate(tickDate);
    if (tickDate && date) {
      const value = `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
      const momentDate = moment(value, 'YYYY/MM/DD');
      return momentDate.locale('fa').format('YYYY/M/D');
    } else {
      return '-';
    }
  }
}
